import { CircleUser } from 'lucide-react';
import { privatePaths } from '@/app/router/paths/privatePaths';

export const getProfileMenuItems = () => [
  { label: 'Mi perfil', icon: CircleUser, path: privatePaths.PROFILE },
];
